<ng-template #content let-modal>
    <div class="modal-header">
      <h4 *ngIf="sTitulo" class="title-copy">{{sTitulo}}</h4>
      <h6 *ngIf="smTitulo"class="title-copy-sub">{{smTitulo}}</h6>
      <h6 *ngIf="confirmationTitle"class="title-copy-sub"><i class="material-icons">error_outline</i> {{confirmationTitle}}</h6>
      <div *ngIf="addIconX" >
          <button *ngIf="!bClose"  class="btn-transparent" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <i style="font-size:32px;" class="sidebar-item-icon material-icons">close</i>
          </button>
      </div>
    </div>
    <div class="modal-body">
       <ng-content select="[body]"></ng-content>
    </div>
    <div class="modal-footer">
      <div *ngIf="bClose" (click)="modal.close()">
        <button type="button" class="btn btn-light-cancel">{{mClose}}</button>
      </div>
      <ng-content select="[cancelar]"></ng-content>
      <ng-content select="[footer]"></ng-content>
    </div>
</ng-template>

